// client/src/components/auth/connectionProblemText.ts (ST-00303)
//
// The words for "LexiBridge can't be reached", shared by the Can't reach
// LexiBridge card (ConnectionProblem), the sign-in form and AuthContext. Kept in a
// module of their own so AuthContext can use them without importing a component.

export const CONNECTION_PROBLEM_TITLE = "Can't reach LexiBridge";

export const CONNECTION_PROBLEM_MESSAGE =
  "LexiBridge can't be reached right now. Check your internet connection — or your company's web filter — and try again.";

export const CONNECTION_PROBLEM_RETRY_NOTE =
  'LexiBridge keeps trying by itself and carries on as soon as it gets through.';
